<template>
    <!-- DESCR：该页面负责论文出版 -->
    <div class="detailpublish-container">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">Proposal to Publish Volume for {{ $route.query.acronym }}</div>
                    <br />
                    <div class="info">
                        You already submitted a proposal. We will consider your proposal and contact you soon.
                    </div>
                    <div class="info">
                        The proposal details are shown below.
                    </div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="primary" :icon="ArrowLeftBold" circle plain></el-button>
            </el-col>
        </el-row>
        <el-row style="margin-bottom: 50px;">
            <el-col :span="12">
                <el-descriptions title="Volume Information"  :column="1" border>
                    <el-descriptions-item label="Volume acronym" label-class-name="label-box1" class-name="content-box1">{{ volumeinfo.acronym }}</el-descriptions-item>
                    <el-descriptions-item label="Volume title" label-class-name="label-box1" class-name="content-box1">{{ volumeinfo.title }}</el-descriptions-item>
                    <el-descriptions-item label="Main area" label-class-name="label-box1" class-name="content-box1">{{ volumeinfo.primaryarea }}</el-descriptions-item>
                    <el-descriptions-item label="Second area" label-class-name="label-box1" class-name="content-box1">{{ volumeinfo.secondaryarea }}</el-descriptions-item>
                    <el-descriptions-item label="Publication date" label-class-name="label-box1" class-name="content-box1">{{ volumeinfo.publicdate }}</el-descriptions-item>
                    <el-descriptions-item label="Publication date strict?" label-class-name="label-box1" class-name="content-box1">{{  Boolean(volumeinfo.isstrict) }}</el-descriptions-item>
                    <el-descriptions-item label="Expected number of papers" label-class-name="label-box1" class-name="content-box1">{{ volumeinfo.number }}</el-descriptions-item>
                    <el-descriptions-item label="Papers already selected?" label-class-name="label-box1" class-name="content-box1">{{ Boolean(volumeinfo.isselected) }}</el-descriptions-item>       
                </el-descriptions>
            </el-col>
        </el-row>
        <el-row style="margin-bottom: 50px;">
            <el-col :span="12">
                <el-descriptions title="Customer Information"  :column="1" border>
                    <el-descriptions-item label="Name" label-class-name="label-box2" class-name="content-box2">{{ volumeinfo.name }}</el-descriptions-item>
                    <el-descriptions-item label="Phone" label-class-name="label-box2" class-name="content-box2">{{ volumeinfo.phone }}</el-descriptions-item>
                    <el-descriptions-item label="Web page" label-class-name="label-box2" class-name="content-box2">{{ volumeinfo.webpape }}</el-descriptions-item>
                    <el-descriptions-item label="Address, line 1" label-class-name="label-box2" class-name="content-box2">{{ volumeinfo.address1 }}</el-descriptions-item>
                    <el-descriptions-item label="Address, line 2" label-class-name="label-box2" class-name="content-box2">{{ volumeinfo.address2 }}</el-descriptions-item>
                    <el-descriptions-item label="City" label-class-name="label-box2" class-name="content-box2">{{  volumeinfo.city }}</el-descriptions-item>
                    <el-descriptions-item label="Post code" label-class-name="label-box2" class-name="content-box2">{{ volumeinfo.postcode }}</el-descriptions-item>  
                </el-descriptions>  
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-descriptions title="Applicant"  :column="1" border>
                    <el-descriptions-item label="Name" label-class-name="label-box3" class-name="content-box3">ShuiZhen He</el-descriptions-item>
                    <el-descriptions-item label="Email" label-class-name="label-box3" class-name="content-box3">1148057331@qq.com</el-descriptions-item>
                    <el-descriptions-item label="Organization" label-class-name="label-box3" class-name="content-box3">华南农业大学</el-descriptions-item>
                </el-descriptions>
            </el-col>
        </el-row>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import request from "../../network/request"
import { ArrowLeftBold } from '@element-plus/icons-vue'
import { saveAs } from 'file-saver';

const route = useRoute()
const volumeinfo = ref({})

onMounted(() => {
    // 下载文件
    saveAs("http://www.gdstinfo.cn/files/conferencefile/common/Fw_+(ISICA+2023+Approval+by+Springer)+Fw_+ISICA+2023+--+CCISPost-proceedings_+Okay!.zip","Fw_+(ISICA+2023+Approval+by+Springer)+Fw_+ISICA+2023+--+CCISPost-proceedings_+Okay!.zip")
    // 获取数据
    request.get(`/volume/${route.query.vid}`).then((res) => {
        if (res.code == 200) {
            volumeinfo.value = res.data
        }
    })
})


</script>

<style lang="scss">
.detailpublish-container {
    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }
    .label-box1{
        width: 50%;
        background-color: #ffdddd0f!important;;
    }
    .content-box1{
        background-color: #ffdddd0f;
    }
    .label-box2{
        width: 50%;
        background-color: #e2ffdd0f!important;;
    }
    .content-box2{
        background-color: #e2ffdd0f;
    }
    .label-box3{
        width: 50%;
        background-color: #b7e6fd0f!important;;
    }
    .content-box3{
        background-color: #b7e6fd0f;
    }
}
</style>